export default (baseData) => ({
    init() {
        this.$watch('selection', () => {
            this.updatePricesAndSummary()
        })
        this.$watch('isEligibleForItalicDiscount', () => {
            this.updatePricesAndSummary()
        })
        this.updatePricesAndSummary()
    },
    license: baseData,
    selection: {
        desktop: {
            id: 'none',
            quantity: 0,
            multiplier: 0
        },
        app: {
            id: 'none',
            quantity: 0,
            multiplier: 0
        },
        web: {
            id: 'none',
            quantity: '0',
            multiplier: 0
        }
    },
    addItalics: false,
    calculatedPrice: 0,
    displayPrice() {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            currency: 'USD',
        });
        return formatter.format(this.calculatedPrice)
    },
    displayUndiscountedPrice() {
        const undiscountedPrice = this.calculatedPrice / this.$store.cart.constants.italicDiscount
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            currency: 'USD',
        });
        return formatter.format(undiscountedPrice)
    },
    info: {
        desktopPrice: 0,
        appPrice: 0,
        webPrice: 0,
        totalPrice: 0,
        formattedPrice: '',
        inCart: false
    },
    updatePricesAndSummary() {
        let price = 0
        let basePrice = this.license.basePrice
        if (this.isEligibleForItalicDiscount) {
            basePrice = basePrice * this.$store.cart.constants.italicDiscount
        }
        this.info.desktopPrice = this.selection.desktop.multiplier * basePrice;
        this.info.webPrice = this.selection.web.multiplier * basePrice;
        this.info.appPrice = this.selection.app.multiplier * basePrice;
        price = this.info.desktopPrice + this.info.webPrice + this.info.appPrice
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            maximumFractionDigits: 2,
            currency: 'USD',
        });
        this.calculatedPrice = price;
        this.info.formattedPrice = this.displayPrice

        let summary = []
        if(this.selection.desktop.quantity > 0) {
            if (this.selection.desktop.quantity === 1) {
                summary.push('1 User')
            } else {
                summary.push(`${this.selection.desktop.quantity} Users`)
            }
        }

        if(this.selection.web.quantity != '0') {
            console.log(this.selection.web.quantity);
            summary.push(`${this.selection.web.quantity} Views / mo`)
        }

        if(this.selection.app.quantity > 0) {
            if (this.selection.app.quantity === 1) {
                summary.push('1 App')
            } else {
                summary.push(`${this.selection.app.quantity} Apps`)
            }
        }
        this.liveSummary = summary.reduce((carry, current) => {
            return `${carry}<span>${current}</span>`
        }, '')
    },
    get inCart() {
        if (!this.$store.cart) {
            return false;
        }
        for (const val of this.$store.cart.data) {
            if (val.item === this.license.target) {
                return true
            }
        }
        return false
    },
    get hasItalicAvailable() {
        if (this.license.matchingItalic) {
            let italicInCart = false
            for (const item of this.$store.cart.data) {
                if (item.item === this.license.matchingItalic) {
                    italicInCart = true
                }
            }
            return !italicInCart
        } else {
            return false
        }
    },
    get isEligibleForItalicDiscount() {
        for (let item of this.$store.cart.data) {
            if (item.matchingItalicId === this.license.target) {
                return true
            }
        }
        return false
    },
    hasCartChanges: false,
    async add() {
        // Ensure we only let users add fonts that they actually have licenses selected for
        if (
            this.selection.desktop.id === 'none' &&
            this.selection.web.id === 'none' &&
            this.selection.app.id === 'none'
        ) {
            return
        }
        const payload = {
            license: this.license.target,
            desktop: this.selection.desktop.id,
            web: this.selection.web.id,
            app: this.selection.app.id,
            addItalics: this.addItalics
        }
        const response = await fetch('/cart', {method: 'POST', body: JSON.stringify({item: payload})})
        const data = await response.json()
        this.$store.cart.replace(data.cart)
    },
    async remove() {
        const response = await fetch('/cart', {method: 'DELETE', body: JSON.stringify({item: this.license.target})})
        const data = await response.json()
        this.$store.cart.replace(data.cart)
    },
    async handleUserSelection(event) {
        console.log({ event })
        this.hasCartChanges = true
    },
    async handleOptionClosed(event) {
        if(event.detail.license === this.license.target) {
            if (!this.inCart && this.hasCartChanges) {
                await this.add()
            }
        }
    }
})
